import { GetProductsByCampaignIdResponse } from "../types/CampaignAdminTypes"
import { IMinimalProduct } from "@ng-mw/platform-interfaces"

/**
 * Maps a `GetProductsByCampaignIdResponse` to an array of `IMinimalProduct` objects.
 *
 * This function extracts the `_source` field from each hit in the response,
 * assuming the structure is `{ hits: { hits: [...] } }` (e.g., from an Elasticsearch query).
 * It returns the `_source` value from each hit as an `IMinimalProduct`.
 *
 * @param {GetProductsByCampaignIdResponse} response - The response containing product data hits.
 * @returns {IMinimalProduct[]} An array of `IMinimalProduct` extracted from the `_source` field of each hit.
 *
 */
export const mapGetProductsByCampaignIdResponseToIMinimalProduct = (
    response: GetProductsByCampaignIdResponse,
): IMinimalProduct[] => {
    return response.hits.hits.map(hit => hit["_source"])
}
